import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePatch, handleDateChangeEvent } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import * as util from '../../../../utils/Util';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import ErrorAwareSelectField from '../../../common/inputfields/ErrorAwareSelectField';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import PaymentMethodFormControl from '../../../common/inputfields/PaymentMethodFormControl';
import ErrorAwareNumberField from '../../../common/inputfields/ErrorAwareNumberField';
// import { result } from 'lodash';

class ModifyEmployee extends Component {

    state = {
        name: this.props.row.employee.name,
        selectedPaymentMethod: enums.outPaymentMethods.find(p => p.value === this.props.row.employee.paymentMethod),
        currentGrossSalary: this.props.row.employee.currentGrossSalary,
        currentNetSalary: this.props.row.employee.currentNetSalary,
        mothersName: this.props.row.employee.mothersName,
        birthPlace: this.props.row.employee.birthPlace,
        birthDate: new Date(this.props.row.employee.birthDate),
        insuranceNumber: this.props.row.employee.insuranceNumber,
        taxNumber: this.props.row.employee.taxNumber,
        address: this.props.row.employee.address,
        prevHighestSchool: this.getHighestSchool(),
        highestSchool: this.getHighestSchool(),
        qualification: this.props.row.employee.qualification,
        wantsVacationAfterKids: this.getTrueFalseValue(this.props.row.employee.wantsVacationAfterKids),
        wantsFamilyDiscount: this.getTrueFalseValue(this.props.row.employee.wantsFamilyDiscount),
        wantsMarriageDiscount: this.getTrueFalseValue(this.props.row.employee.wantsMarriageDiscount),
        eligibleForDisabilityDiscount: this.getTrueFalseValue(this.props.row.employee.eligibleForDisabilityDiscount),
        startDate: new Date(this.props.row.startDate),
        endDate: this.props.row.endDate ? new Date(this.props.row.endDate) : null,
        definiteContractEnd: this.props.row.employee.definiteContractEnd ? new Date(this.props.row.employee.definiteContractEnd) : null,
        workingHours: this.props.row.employee.workingHours,
        haveExitPapersFromPreviousEmployment: this.getTrueFalseValue(this.props.row.employee.haveExitPapersFromPreviousEmployment),
        haveTbBook: this.getTrueFalseValue(this.props.row.employee.haveTbBook),
        currentVacationDays: this.props.row.employee.currentVacationDays,
        haveDriverLicense: this.getTrueFalseHavingValue(this.props.row.employee.haveDriverLicense),
        errors: new Map(),
    }

    getTrueFalseValue(value) {
        if (value === null) {
            value = "null";
        }
        let result = enums.trueFalse.find(p => p.value === value.toString());
        return result;
    }

    getTrueFalseHavingValue(value) {
        if (value === null) {
            value = "null";
        }
        let result = enums.trueFalseHaving.find(p => p.value === value.toString());
        return result;
    }

    getHighestSchool() {
        let value = this.props.row.employee.highestSchool;
        if (!this.props.row.employee.highestSchool) {
            value = "NONE";
        }
        return enums.highestSchool.find(p => p.value === value);
    }

    componentDidMount() {
        if (this.props.row) {
            console.log(this.props.row)
        }
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/employee';
        const requestObject = {
            "privateId": this.props.row.employee.privateId,
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "currentGrossSalary": util.toNumber(this.state.currentGrossSalary),
            "currentNetSalary": util.toNumber(this.state.currentNetSalary),
            "name": this.state.name,
            "mothersName": this.state.mothersName,
            "birthPlace": this.state.birthPlace,
            "birthDate": this.state.birthDate,
            "insuranceNumber": this.state.insuranceNumber,
            "taxNumber": this.state.taxNumber,
            "address": this.state.address,
            "highestSchool": this.state.highestSchool.value,
            "qualification": this.state.qualification,
            "wantsVacationAfterKids": this.state.wantsVacationAfterKids.value,
            "wantsFamilyDiscount": this.state.wantsFamilyDiscount.value,
            "wantsMarriageDiscount": this.state.wantsMarriageDiscount.value,
            "eligibleForDisabilityDiscount": this.state.eligibleForDisabilityDiscount.value,
            "startDate": this.state.startDate,
            "endDate": this.state.endDate,
            "definiteContractEnd": this.state.definiteContractEnd ? new Date(this.state.definiteContractEnd) : null,
            "workingHours": this.state.workingHours,
            "haveExitPapersFromPreviousEmployment": this.state.haveExitPapersFromPreviousEmployment.value,
            "haveTbBook": this.state.haveTbBook.value,
            "currentVacationDays": this.state.currentVacationDays,
            "active": this.props.row.employee.active,
            "type": this.props.row.employee.type,
            "haveDriverLicense": this.state.haveDriverLicense.value,
        };
        console.log(requestObject);
        handlePatch(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="name"
                            label="Név"
                            errors={this.state.errors}
                            value={this.state.name}
                            prevValue={this.props.row.employee.name}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="mothersName"
                            label="Anyja neve"
                            errors={this.state.errors}
                            value={this.state.mothersName}
                            prevValue={this.props.row.employee.mothersName}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="birthPlace"
                            label="Születési hely"
                            errors={this.state.errors}
                            value={this.state.birthPlace}
                            prevValue={this.props.row.employee.birthPlace}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareDatePicker
                            name="birthDate"
                            label="Születési idő"
                            errors={this.state.errors}
                            value={this.state.birthDate}
                            prevValue={this.props.row.employee.birthDate}
                            onChange={e => handleDateChangeEvent(e, "birthDate", this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="insuranceNumber"
                            label="TAJ szám"
                            errors={this.state.errors}
                            value={this.state.insuranceNumber}
                            prevValue={this.props.row.employee.insuranceNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="taxNumber"
                            label="Adószám"
                            errors={this.state.errors}
                            value={this.state.taxNumber}
                            prevValue={this.props.row.employee.taxNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    {this.props.row.employee.type === "FULL_TIME"
                        && <>
                            <div className='input-group-3'>
                                <ErrorAwareAmountField
                                    id="currentGrossSalary"
                                    name="currentGrossSalary"
                                    label="Bruttó fizetés"
                                    errors={this.state.errors}
                                    value={this.state.currentGrossSalary}
                                    prevValue={this.props.row.employee.currentGrossSalary}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareAmountField
                                    id="currentNetSalary"
                                    name="currentNetSalary"
                                    label="Nettó fizetés"
                                    errors={this.state.errors}
                                    value={this.state.currentNetSalary}
                                    prevValue={this.props.row.employee.currentNetSalary}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-3'>
                                <PaymentMethodFormControl
                                    options={enums.outPaymentMethods}
                                    value={this.state.selectedPaymentMethod}
                                    prevValue={enums.getObjectByValue(enums.outPaymentMethods, this.props.row.employee.paymentMethod)}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                        </>}
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="address"
                            label="Cím"
                            errors={this.state.errors}
                            value={this.state.address}
                            prevValue={this.props.row.employee.address}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareSelectField
                            labelId="highest-school-label"
                            id="highest-school"
                            name="highestSchool"
                            label="Legmagasabb iskolai végzettség"
                            errors={this.state.errors}
                            value={this.state.highestSchool}
                            prevValue={enums.getObjectByValue(enums.highestSchool, this.state.prevHighestSchool)}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.highestSchool} />
                    </div>
                    <div className='input-group-3'>
                        <ErrorAwareTextField
                            name="qualification"
                            label="Szakképzettség"
                            errors={this.state.errors}
                            value={this.state.qualification}
                            prevValue={this.props.row.employee.qualification}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    {this.props.row.employee.type === "FULL_TIME"
                        && <>
                            <div className='input-group-3'>
                                <ErrorAwareDatePicker
                                    name="startDate"
                                    label="Jogviszony kezdete"
                                    errors={this.state.errors}
                                    value={this.state.startDate}
                                    prevValue={this.props.row.startDate}
                                    onChange={e => handleDateChangeEvent(e, "startDate", this)} />
                            </div>
                            {this.props.row.employee.active ? <></> :
                                <div className='input-group-3'>
                                    <ErrorAwareDatePicker
                                        name="endDate"
                                        label="Jogviszony vége"
                                        errors={this.state.errors}
                                        value={this.state.endDate}
                                        prevValue={this.props.row.endDate}
                                        onChange={e => handleDateChangeEvent(e, "endDate", this)} />
                                </div>}
                            <div className='input-group-3'>
                                <ErrorAwareDatePicker
                                    name="definiteContractEnd"
                                    label="Határozott idő lejárta"
                                    errors={this.state.errors}
                                    value={this.state.definiteContractEnd}
                                    prevValue={this.props.row.employee.definiteContractEnd}
                                    onChange={e => handleDateChangeEvent(e, "definiteContractEnd", this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareNumberField
                                    id="workingHours"
                                    name="workingHours"
                                    label="Napi munkaidő (óra)"
                                    errors={this.state.errors}
                                    value={this.state.workingHours}
                                    prevValue={this.props.row.employee.workingHours}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareNumberField
                                    id="currentVacationDays"
                                    name="currentVacationDays"
                                    label="Szabadság napok"
                                    errors={this.state.errors}
                                    value={this.state.currentVacationDays}
                                    prevValue={this.props.row.employee.currentVacationDays}
                                    onChange={e => handleChangeEvent(e, this)} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="vac-after-kids-label"
                                    id="vac-after-kids"
                                    name="wantsVacationAfterKids"
                                    label="Igényt tart-e gyerekek után járó pótszabadságra?"
                                    errors={this.state.errors}
                                    value={this.state.wantsVacationAfterKids}
                                    prevValue={enums.getObjectByValue(enums.trueFalse, this.props.row.employee.wantsVacationAfterKids)}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="family-discount"
                                    id="family-discount"
                                    name="wantsFamilyDiscount"
                                    label="Igényt tart-e családi kedvezményre?"
                                    errors={this.state.errors}
                                    value={this.state.wantsFamilyDiscount}
                                    prevValue={enums.getObjectByValue(enums.trueFalse, this.props.row.employee.wantsVacationAfterKids)}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="marriage-discount-label"
                                    id="marriage-discount"
                                    name="wantsMarriageDiscount"
                                    label="Igényt tart-e első házasok kedvezményére?"
                                    errors={this.state.errors}
                                    value={this.state.wantsMarriageDiscount}
                                    prevValue={enums.getObjectByValue(enums.trueFalse, this.props.row.employee.wantsMarriageDiscount)}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="disability-discount-label"
                                    id="disability-discount"
                                    name="eligibleForDisabilityDiscount"
                                    label="Jogosult-e fogyatékos kedvezményre?"
                                    errors={this.state.errors}
                                    value={this.state.eligibleForDisabilityDiscount}
                                    prevValue={enums.getObjectByValue(enums.trueFalse, this.props.row.employee.eligibleForDisabilityDiscount)}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="exit-papers-label"
                                    id="exit-papers"
                                    name="haveExitPapersFromPreviousEmployment"
                                    label="Adott-e le előző munkaviszony leszámoló papírjait?"
                                    errors={this.state.errors}
                                    value={this.state.haveExitPapersFromPreviousEmployment}
                                    prevValue={enums.getObjectByValue(enums.trueFalse, this.props.row.employee.haveExitPapersFromPreviousEmployment)}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                            <div className='input-group-3'>
                                <ErrorAwareSelectField
                                    labelId="have-tb-book-label"
                                    id="have-tb-book"
                                    name="haveTbBook"
                                    label="Adott-e le tb kiskönyvet?"
                                    errors={this.state.errors}
                                    value={this.state.haveTbBook}
                                    prevValue={enums.getObjectByValue(enums.trueFalse, this.props.row.employee.haveTbBook)}
                                    onChange={e => handleChangeEvent(e, this)}
                                    options={enums.trueFalse} />
                            </div>
                        </>}
                    <div className='input-group-3'>
                        <ErrorAwareSelectField
                            labelId="have-driver-license-label"
                            id="have-driver-license"
                            name="haveDriverLicense"
                            label="Van-e jogosítványa?"
                            errors={this.state.errors}
                            value={this.state.haveDriverLicense}
                            prevValue={enums.getObjectByValue(enums.trueFalseHaving, this.props.row.employee.haveDriverLicense)}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.trueFalseHaving} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Mentés
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyEmployee);
